// @ts-nocheck
import React from 'react'
import { DropdownTitle } from '../../../generic'
import {
  EmarStockAlertField,
  EmarStockUnitsField,
  EmarCurrentStockField
} from '../fields'

interface EmarStockFieldsSectionProps {
  editState: boolean
  testId?: string
  // Add other props as needed
}

const EmarStockFieldsSection: React.FC<EmarStockFieldsSectionProps> = (
  props
) => {
  const { testId } = props
  return (
    <div
      style={styles.container}
      data-testid={
        testId ? `${testId}-stock-fields-section` : 'stock-fields-section'
      }
    >
      <DropdownTitle
        isOpen
        title="Stock"
        data-testid={testId ? `${testId}-stock-dropdown` : 'stock-dropdown'}
      >
        <EmarStockUnitsField {...props} />
        <EmarStockAlertField {...props} />
        {!props.editState && <EmarCurrentStockField {...props} />}
      </DropdownTitle>
    </div>
  )
}

const styles = {
  container: {
    width: '100%'
  }
}

export default EmarStockFieldsSection
